import { createContext } from "react";

const AlertContext = createContext();
AlertContext.displayName = "AlertContext";
export default AlertContext;
